import { _ } from "../../core/polyglot/polyglot.js";
import { formatAsMonthAndYear } from "../../core/helpers/date-formatting-util.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 * Displays a panel of reports that are displayed as document icons.
 *
 * @example
 * html.render(reportDocumentsPaneldWidget({ type: 'income', year: someFiscalYear}))
 * @param {object} spec - Parameter object
 * @param {fiscalYear} spec.year - A fiscal year
 * @param {string} spec.type - Either 'income' or 'balance'
 * @param {object} my - protected fields holder
 */
function reportDocumentsPanelWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	const baseUrl = spec.type;
	const currentPeriod = spec.currentPeriod;
	const year = spec.currentPeriod.getYear();

	that.renderContentOn = function (html) {
		html.div(
			{ class: "panel" },
			html.div(
				{ class: "panel-body" },
				html.div(
					{ class: "reports-block-segment" },
					html.div({ class: "panel-title" }, html.h4(_("Months"))),
					html.div(
						{ class: "container" },
						monthsRenderer(year.asMonthsWithinActivePeriod()),
					),
				),
				bimestersRenderer,
				html.div(
					{ class: "reports-block-segment" },
					html.div({ class: "panel-title" }, html.h4(_("Quarters"))),
					html.div(
						{ class: "container" },
						periodsRenderer(year.asQuartersWithinActivePeriod()),
					),
				),
				html.div(
					{ class: "reports-block-segment" },
					html.div({ class: "panel-title" }, html.h4(_("Years"))),
					html.div(
						{ class: "container" },
						periodsRenderer(year.asHalfYearsWithinActivePeriod()),
						periodsRenderer([year]),
					),
				),
			),
		);
	};

	function bimestersRenderer(html) {
		const bimesters = year.asBimestersWithinActivePeriod();
		if (bimesters.length) {
			html.div(
				{ class: "reports-block-segment" },
				html.div({ class: "panel-title" }, html.h4(_("Bimesters"))),
				html.div({ class: "container" }, periodsRenderer(bimesters)),
			);
		}
	}

	function periodsRenderer(periods) {
		return function (html) {
			periods.map((period) =>
				html.div(
					{ class: cssClassForPeriod(period) },
					html.a(
						{
							href: my.linkTo(baseUrl, {
								period: period.toString(),
							}),
						},
						period.getName(),
					),
				),
			);
		};
	}

	function monthsRenderer(months) {
		return function (html) {
			months.map((month) =>
				html.div(
					{ class: cssClassForPeriod(month) },
					html.a(
						{
							href: my.linkTo(baseUrl, {
								period: month.toString(),
							}),
						},
						formatAsMonthAndYear(month.getStart()),
					),
				),
			);
		};
	}

	function cssClassForPeriod(period) {
		if (period.equals(currentPeriod)) {
			return `fp-icon ${period
				.getPeriodType()
				.toLowerCase()}-icon ${period
				.getPeriodId()
				.toLowerCase()}-icon current`;
		}
		return `fp-icon ${period.getPeriodType().toLowerCase()}-icon ${period
			.getPeriodId()
			.toLowerCase()}-icon`;
	}

	return that;
}

export default reportDocumentsPanelWidget;
